import { create } from 'zustand';

const usePayoutStore = create((set) => ({
    // Holds the current payout data
    payoutDetail: {},

    // Replace the entire payout object
    setPayoutDetail: (newDetail) => set({ payoutDetail: newDetail }),

    // Reset to an empty object
    clearPayoutDetail: () => set({ payoutDetail: {} }),
}));

export default usePayoutStore;
